import type { EditorReadyFn } from '@wix/yoshi-flow-editor';

import { Experiment } from '../../constants';
import { globalAppState } from '../../editor/services';
import {
  monitoredTransactionFactory,
  toMonitored,
} from '../../editor/services/monitor';
import { uninstallIfProvisionedWithoutMembersArea } from '../common/uninstallation';
import { installMemberSettingsPage, installProfilePage } from './installation';
import { addEventsListeners } from './listeners';
import { getIsEditor3, isSplitPlatformAppValid } from './utils';

export const editorReady: EditorReadyFn = (
  editorSDK,
  appDefinitionId,
  options,
  flowAPI,
) => {
  const monitoredTransaction = monitoredTransactionFactory(editorSDK);
  const originInfo = options.origin.info as Record<string, any> | undefined;
  const isSocialInstallation = Boolean(originInfo?.isSocialInstallation);

  const shouldAllowInstallingProfileE3 = flowAPI.experiments.enabled(
    Experiment.AllowInstallingProfileE3,
  );

  const installAction = async () => {
    const context = {
      editorSDK,
      options,
      appDefinitionId,
      flowAPI,
    };

    const isEditor3 = getIsEditor3();

    return Promise.all([
      installMemberSettingsPage(context),
      isSocialInstallation &&
      (!isEditor3 || (isEditor3 && shouldAllowInstallingProfileE3))
        ? installProfilePage(context)
        : Promise.resolve(),
    ]);
  };

  const editorReadyAction = async () => {
    if (!options.firstInstall) {
      const { uninstalled } = await uninstallIfProvisionedWithoutMembersArea(
        editorSDK,
      );

      if (uninstalled || !(await isSplitPlatformAppValid(editorSDK))) {
        return;
      }

      // TODO: Implement fixers for Settings and Profile page tabs.
    }

    if (options.firstInstall) {
      await monitoredTransaction('ma-split.install', installAction);
      globalAppState.disableRoutesRefresh();
    }

    await addEventsListeners(editorSDK, flowAPI);
  };

  return toMonitored('ma-split.editorReady', editorReadyAction);
};
